import { configureStore, Action, ThunkAction } from "@reduxjs/toolkit"
import storage from "redux-persist/lib/storage"
import { persistCombineReducers, persistStore } from "redux-persist"
import { dealerCandidateReducer, dealerReportReducer, userReducer, weeklyFilterReducer } from "./reducers"
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2"

const reducers = {
    user: userReducer,
    weeklyFilters: weeklyFilterReducer,
    dealerFilters: dealerCandidateReducer,
    reportFilters: dealerReportReducer
}

const persistConfig = {
    key: "root",
    storage: storage,
    version: 1,
    stateReconciler: autoMergeLevel2,
    whitelist: ["user", "weeklyFilters", "dealerFilters", "reportFilters"],
}

const persistedReducer = persistCombineReducers(persistConfig, reducers)

export const store = configureStore({
    reducer: persistedReducer,
})

export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>

export const persistor = persistStore(store)
